import useGameDefinition from '@/src/hooks/data/useGameDefinition';
import styles from './A23TableTile.module.css';
import { RUPEE_SYMBOL } from '@/Poker/data/Constants';
import gameAssets from '@themed-assets';
import { FaUserAlt } from "react-icons/fa";
import { IoChevronForwardOutline } from "react-icons/io5";
import useCreateGame from '@/src/hooks/utils/useCreateGame';
import { parseDecimalValuesOfNumber } from '@/Common/utils/GameUtils';
import useActiveTableIdFinder from '@/src/hooks/data/useActiveTableIdFinder';
import { useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';
import { updateActiveGame } from '@/Poker/redux/slices/gameTableSlice';
import usePlayerBalance from '@/src/hooks/data/usePlayerBalance';
import { showBuyInPopupInLobby } from '@/Poker/redux/slices/lobbySlice';
import useRestrictions from '@/src/hooks/data/useRestrictions';

export default function A23TableTile({ tableData }) {
  const { averageChipsStack, maximumPlayers, seatedPlayerCount, gameDefId, maximumBuyIn, minimumBuyIn } = tableData;
  const gameDefinition = useGameDefinition(gameDefId);
  const { initiateCreateTable } = useCreateGame();
  const isRIT = gameDefinition.isRITEnabled;
  const isStraddle = gameDefinition.isStraddleEnabled;
  const isTurbo = gameDefinition.turbo;
  const isDeep = gameDefinition.isDeep;
  const isHappyHours = gameDefinition.happyHoursEnabled;
  const hasVariant = isRIT || isStraddle || isTurbo || isDeep || isHappyHours;
  const { isTableActive, tempTableId } = useActiveTableIdFinder(tableData?.tableId);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { restrictionCheck } = useRestrictions();

  if (!Object.keys(gameDefinition).length > 0 || gameDefinition?.status?.toLowerCase() === 'inactive') {
    return null;
  }

  const handleTableTileClick = () => restrictionCheck(() => {
    if (isTableActive) {
      dispatch(updateActiveGame(tempTableId))
      navigate('/game');
      return;
    }
    initiateCreateTable(gameDefinition, tableData.tableId)
  }, true)

  return (
    <div onClick={() => handleTableTileClick()} className={`${styles.roomTile} ${hasVariant ? styles.hasVariant : ''}`}>
      {/* Top Row */}
      <div className={styles.topRow}>
        <div className={styles.potAmount}>
          <img className={styles.cashIcon} src={gameAssets.cashIcon} />
          {parseDecimalValuesOfNumber(averageChipsStack, 2, true)}
        </div>
        <div className={styles.playersCount}>
          <FaUserAlt color={'var(--color-success)'} size={12} />
          <div className={styles.playersCountContainer}>
            <span className={styles.seatedPlayerCount}>{seatedPlayerCount}</span>
            <span className={styles.slash}>/</span>
            <span className={styles.maximumPlayers}>{maximumPlayers}</span>
          </div>
        </div>
        <div className={styles.blindsSection}>
          <span className={styles.blinds}>
            {RUPEE_SYMBOL + parseDecimalValuesOfNumber(minimumBuyIn, 2, true)}/{RUPEE_SYMBOL + parseDecimalValuesOfNumber(maximumBuyIn, 2, true)}
          </span>
          {/* <IoChevronForwardOutline color={'var(--color-secondary)'} size={14} /> */}
        </div>
      </div>

      {
        hasVariant || isTableActive ? (
          <div className={`${styles.bottomRow} ${isTableActive && !hasVariant ? styles.flexEnd : ''}`}>
            <div className={styles.variantIcons}>
              {
                isRIT && <img src={gameAssets.rit} className={styles.variantIcon} style={{ height: '20px' }} />
              }
              {
                isStraddle && <div className={styles.variantText}>⚡</div>
              }
              {
                isTurbo && <div className={styles.variantText}>🔥</div>
              }
              {
                isDeep && <img src={gameAssets.deep} className={styles.variantIcon} />
              }
              {
                isHappyHours && <img src={gameAssets.happyHours} className={styles.variantIcon} />
              }
            </div>
            {
              isTableActive ? (
                <div className={styles.tableStatus}>
                  <div className={styles.greenDot}></div>
                  Active
                </div>
              ) : null
            }
          </div>
        ) : null
      }
    </div>
  );
}